import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAirlockModuleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 12,
			fill: "url(#paint0_linear_1740_107150)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2243 21.9553C35.2297 21.8341 35.2334 21.7121 35.2334 21.5897C35.2337 17.1219 31.6087 13.5 27.1368 13.5C23.8986 13.5 21.1056 15.4003 19.8109 18.1446C19.0915 17.6318 18.2031 17.3278 17.241 17.3278C14.8474 17.3278 12.9072 19.2038 12.9072 21.5172C12.9072 21.8608 12.9508 22.1945 13.0316 22.5137C10.301 23.0953 8.25 25.5648 8.25 28.5237C8.25 31.9147 10.9433 34.5003 14.2655 34.5003H33.9935C37.1727 34.5003 39.75 31.7855 39.75 28.235C39.75 25.1566 37.8119 22.585 35.2243 21.9553ZM27.7823 30.8208H22.2263C21.7754 30.8208 21.4471 30.3931 21.5637 29.9576L22.9466 24.789C22.1046 24.1687 21.6061 23.1861 21.6035 22.1404C21.6035 20.2584 23.1291 18.7328 25.011 18.7328C26.893 18.7328 28.4186 20.2584 28.4186 22.1404C28.4166 23.1855 27.9198 24.1682 27.0792 24.789L28.4455 29.9596C28.5604 30.3948 28.2324 30.8208 27.7823 30.8208Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1740_107150",
			x1: 0,
			y1: 48,
			x2: 48,
			y2: 0,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5C5C5C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CCCCCC"
			})]
		}) })
	]
});
export { SvgAirlockModuleIcon as ReactComponent };
